import {
  markAllNotificationsAsReadResponse,
  notificationSchema,
  notificationsResponseSchema,
} from '@/types/notifications';
import { SortOrderOptions, SortOrderValues } from '@/types/sort';
import { INTERNAL_V1, damRequest } from '@/hooks/damRequest';

const BASE = `${INTERNAL_V1}/notifications`;

export const getNotifications = async (
  params: {
    pagination: { limit: number | null; offset: number | null };
    sort: { order: string; value: string };
  },
  token?: string,
) => {
  const response = await damRequest(
    'GET',
    `${BASE}?offset=${params.pagination?.offset ?? ''}&limit=${params.pagination?.limit ?? ''}&sortBy=${
      params?.sort?.value ?? SortOrderValues.CREATED_AT
    }&sortOrder=${params?.sort?.order ?? SortOrderOptions.ASC}`,
    token,
  );

  return notificationsResponseSchema.parse(response);
};

export const markNotificationAsRead = async (params: { notificationId: string; read: boolean }, token?: string) => {
  const response = await damRequest('PATCH', `${BASE}/${params.notificationId}`, token, {
    body: { read: params.read },
  });

  return notificationSchema.parse(response);
};

export const markAllNotificationsAsRead = async (params: null, token?: string) => {
  const response = await damRequest('PATCH', BASE, token, { body: { read: true } });

  return markAllNotificationsAsReadResponse.parse(response);
};
